
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#fff"}},[_c('path',{attrs:{"d":"M0 11.406c0 .164.115.293.279.293h.445c.3-.66.981-1.16 1.772-1.16.792 0 1.473.5 1.772 1.16h5.79V9.33H0v2.076z"}}),_c('path',{attrs:{"d":"M2.496 11.165a1.313 1.313 0 100 2.626 1.313 1.313 0 000-2.626zM15.83 8.365l-1.251-.55h-3.9V11.7h.758c.299-.66.98-1.16 1.771-1.16.792 0 1.473.5 1.772 1.16h.741c.164 0 .279-.129.279-.293V8.648a.302.302 0 00-.17-.283zM13.293 5.576a.892.892 0 00-.805-.48H10.68v2.098h3.453l-.84-1.618zM9.166 3H.887C.387 3 0 3.411 0 3.91V8.71h10.058V3.91v-.004A.9.9 0 009.166 3z"}}),_c('path',{attrs:{"d":"M13.209 11.165a1.313 1.313 0 100 2.626 1.313 1.313 0 000-2.626z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    